(function() {
  /* i18n: словарь в assets/whatsapp-popup-i18n.js (window.WA_I18N), язык — из <html lang>. */
  var WA_DICT = window.WA_I18N || {};
  var WA_LANG = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var WA_T = WA_DICT[WA_LANG] || WA_DICT.en || {};
  function t(key, vars) {
    var s = WA_T[key] || (WA_DICT.en && WA_DICT.en[key]) || '';
    if (vars) {
      for (var k in vars) { s = s.split('{' + k + '}').join(vars[k]); }
    }
    return s;
  }
  document.querySelectorAll('[data-wa-i18n]').forEach(function(el) {
    var val = t(el.getAttribute('data-wa-i18n'));
    if (!val) return;
    var attr = el.getAttribute('data-wa-i18n-attr');
    if (attr) { el.setAttribute(attr, val); } else { el.textContent = val; }
  });

  var btn = document.getElementById('wa-btn');
  var overlay = document.getElementById('wa-overlay');
  var closeBtn = document.getElementById('wa-close');
  var nextBtn = document.getElementById('wa-next');
  var backBtn = document.getElementById('wa-back');
  var submitBtn = document.getElementById('wa-submit');
  var errorBox = document.getElementById('wa-error');
  var nameInput = document.getElementById('wa-name');
  var emailInput = document.getElementById('wa-email');
  var phoneInput = document.getElementById('wa-phone');
  var messageInput = document.getElementById('wa-message');
  var step1 = document.getElementById('wa-step-1');
  var step2 = document.getElementById('wa-step-2');
  var ind1 = document.getElementById('wa-step-ind-1');
  var ind2 = document.getElementById('wa-step-ind-2');

  var WA_NUMBER = '40748339617';

  var COUNTRY_CODES = [
    { code: '1876', len: 7 },
    { code: '1869', len: 7 },
    { code: '1868', len: 7 },
    { code: '1849', len: 7 },
    { code: '1829', len: 7 },
    { code: '1809', len: 7 },
    { code: '1784', len: 7 },
    { code: '1767', len: 7 },
    { code: '1758', len: 7 },
    { code: '1721', len: 7 },
    { code: '1684', len: 7 },
    { code: '1671', len: 7 },
    { code: '1664', len: 7 },
    { code: '1649', len: 7 },
    { code: '1473', len: 7 },
    { code: '1441', len: 7 },
    { code: '1345', len: 7 },
    { code: '1340', len: 7 },
    { code: '1284', len: 7 },
    { code: '1268', len: 7 },
    { code: '1264', len: 7 },
    { code: '1246', len: 7 },
    { code: '1242', len: 7 },
    { code: '998', len: 9 },
    { code: '996', len: 9 },
    { code: '995', len: 9 },
    { code: '994', len: 9 },
    { code: '993', len: 8 },
    { code: '992', len: 9 },
    { code: '977', len: 10 },
    { code: '976', len: 8 },
    { code: '975', len: 8 },
    { code: '974', len: 8 },
    { code: '973', len: 8 },
    { code: '972', len: 9 },
    { code: '971', len: 9 },
    { code: '970', len: 9 },
    { code: '968', len: 8 },
    { code: '967', len: 9 },
    { code: '966', len: 9 },
    { code: '965', len: 8 },
    { code: '964', len: 10 },
    { code: '963', len: 9 },
    { code: '962', len: 9 },
    { code: '961', len: 8 },
    { code: '960', len: 7 },
    { code: '886', len: 9 },
    { code: '880', len: 10 },
    { code: '856', len: 10 },
    { code: '855', len: 9 },
    { code: '853', len: 8 },
    { code: '852', len: 8 },
    { code: '850', len: 10 },
    { code: '84',  len: 10 },
    { code: '82',  len: 10 },
    { code: '81',  len: 11 },
    { code: '66',  len: 9 },
    { code: '65',  len: 8 },
    { code: '64',  len: 9 },
    { code: '63',  len: 10 },
    { code: '62',  len: 11 },
    { code: '61',  len: 9 },
    { code: '60',  len: 10 },
    { code: '58',  len: 10 },
    { code: '57',  len: 10 },
    { code: '56',  len: 9 },
    { code: '55',  len: 11 },
    { code: '54',  len: 10 },
    { code: '53',  len: 8 },
    { code: '52',  len: 10 },
    { code: '51',  len: 9 },
    { code: '49',  len: 11 },
    { code: '48',  len: 9 },
    { code: '47',  len: 8 },
    { code: '46',  len: 9 },
    { code: '45',  len: 8 },
    { code: '44',  len: 10 },
    { code: '43',  len: 10 },
    { code: '41',  len: 9 },
    { code: '40',  len: 9 },
    { code: '39',  len: 10 },
    { code: '38',  len: 9 },
    { code: '36',  len: 9 },
    { code: '34',  len: 9 },
    { code: '33',  len: 9 },
    { code: '32',  len: 9 },
    { code: '31',  len: 9 },
    { code: '30',  len: 10 },
    { code: '27',  len: 9 },
    { code: '20',  len: 10 },
    { code: '7',   len: 10 },
    { code: '1',   len: 10 }
  ];

  function getCountryRule(digits) {
    for (var i = 0; i < COUNTRY_CODES.length; i++) {
      var c = COUNTRY_CODES[i];
      if (digits.startsWith(c.code)) {
        return c;
      }
    }
    return null;
  }

  function phoneValidationError(phone) {
    var digits = phone.replace(/\D/g, '');
    if (!digits) return t('err_phone');

    var rule = getCountryRule(digits);
    if (!rule) {
      if (digits.length < 7 || digits.length > 15) {
        return t('err_phone_len');
      }
      return null;
    }

    var expectedTotal = rule.code.length + rule.len;
    if (digits.length !== expectedTotal) {
      var diff = digits.length - expectedTotal;
      if (diff > 0) {
        return t('err_too_many', { code: rule.code, n: digits.length, e: expectedTotal });
      } else {
        return t('err_too_few', { code: rule.code, n: digits.length, e: expectedTotal });
      }
    }
    return null;
  }

  function isValidPhone(phone) {
    return phoneValidationError(phone) === null;
  }

  phoneInput.addEventListener('input', function() {
    var pos = this.selectionStart;
    var cleaned = this.value.replace(/[-\s]/g, '');
    if (!cleaned.startsWith('+')) {
      cleaned = '+' + cleaned.replace(/^\+*/, '');
    }
    if (this.value !== cleaned) {
      var diff = this.value.length - cleaned.length;
      this.value = cleaned;
      var newPos = Math.max(1, pos - diff);
      this.setSelectionRange(newPos, newPos);
    }
  });

  phoneInput.addEventListener('keydown', function(e) {
    if ((e.key === 'Backspace' || e.key === 'Delete') && this.value === '+') {
      e.preventDefault();
    }
  });


  function setStep(n) {
    step1.classList.toggle('active', n === 1);
    step2.classList.toggle('active', n === 2);
    ind1.classList.toggle('done', n >= 1);
    ind2.classList.toggle('done', n >= 2);
    clearErrors();
  }

  function setInboxChatVisible(visible) {
    var chatHost = document.querySelector('shopify-chat');
    if (!chatHost) return;
    if (visible) {
      chatHost.style.removeProperty('z-index');
    } else {
      chatHost.style.setProperty('z-index', '9998', 'important');
    }
  }

  function openModal() {
    var modal = document.getElementById('wa-modal');
    modal.classList.remove('closing');
    overlay.classList.add('active');
    btn.classList.add('wa-btn-open');
    setInboxChatVisible(false);
    setStep(1);
    messageInput.focus();
  }

  function closeModal() {
    var modal = document.getElementById('wa-modal');
    // Sequencing: the modal disappears first; the button's own
    // grow-back animation is deliberately delayed so it becomes
    // visible only once the modal has mostly faded/scaled out,
    // instead of animating underneath it at the same instant.
    // Independent of the Inbox z-index restore below, which
    // intentionally waits longer.
    modal.classList.add('closing');
    setTimeout(function() {
      btn.style.transition = 'none';
      btn.classList.remove('wa-btn-open');
      void btn.offsetWidth;
      requestAnimationFrame(function() {
        btn.style.transition = '';
      });
    }, 170);
    setTimeout(function() {
      overlay.classList.remove('active');
      modal.classList.remove('closing');
      messageInput.value = '';
      nameInput.value = '';
      emailInput.value = '';
      phoneInput.value = '';
      setStep(1);
    }, 250);
    setTimeout(function() {
      setInboxChatVisible(true);
    }, 470);
  }

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.style.display = 'block';
  }

  function clearErrors() {
    errorBox.style.display = 'none';
    nameInput.classList.remove('error');
    emailInput.classList.remove('error');
    phoneInput.classList.remove('error');
    messageInput.classList.remove('error');
  }

  function setLoading(on) {
    submitBtn.disabled = on;
    submitBtn.classList.toggle('loading', on);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    openModal();
  });

  closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    closeModal();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  nextBtn.addEventListener('click', function() {
    clearErrors();
    var message = messageInput.value.trim();
    if (!message) {
      messageInput.classList.add('error');
      showError(t('err_message'));
      return;
    }
    setStep(2);
    nameInput.focus();
  });

  backBtn.addEventListener('click', function() {
    setStep(1);
  });

  submitBtn.addEventListener('click', function() {
    clearErrors();

    var name = nameInput.value.trim();
    var email = emailInput.value.trim();
    var phone = phoneInput.value.trim();
    var message = messageInput.value.trim();
    var valid = true;

    if (!name) {
      nameInput.classList.add('error');
      valid = false;
    }

    if (!email || !isValidEmail(email)) {
      emailInput.classList.add('error');
      valid = false;
    }

    var phoneErr = !phone ? t('err_phone') : phoneValidationError(phone);
    if (phoneErr) {
      phoneInput.classList.add('error');
      valid = false;
    }

    if (!valid) {
      var errMsg = t('err_check');
      if (!name) errMsg = t('err_name');
      else if (!email || !isValidEmail(email)) errMsg = t('err_email');
      else if (phoneErr) errMsg = phoneErr;
      showError(errMsg);
      return;
    }

    setLoading(true);

    var n8nPromise = fetch('https://vifine.app.n8n.cloud/webhook/whatsapp-widget-lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: name,
        email: email,
        phone: phone,
        message: message,
        source: 'WhatsApp widget'
      })
    }).catch(function(err) {
      console.log('[n8n] Error (non-critical):', err);
      return null;
    });

    n8nPromise.then(function() {
      setLoading(false);
      closeModal();
      var whatsappUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(message);
      window.open(whatsappUrl, '_blank');
    }).catch(function(err) {
      console.error('[WhatsApp] Error:', err);
      setLoading(false);
      showError(t('err_generic'));
    });
  });

  window.waOpenModal = openModal;

  console.log('[WhatsApp] Script loaded successfully');
})();
